<template>
  <div>
    <!--  产品订购-->
    <a-modal
      width="1250px"
      :dialogStyle="{ top: '5%' }"
      :visible="visible"
      :footer="null"
      @cancel="handleClose"
    >
      <template slot="title">
        <span style="font-weight: 550; color: #333333; font-size: 20px"
          >产品订购</span
        >
      </template>
      <div style="margin-bottom: 80px">
        <div class="ProductOrdering-title">
          <div>服务介绍</div>
        </div>
        <div class="notice">
          <div v-html="service.service.serviceIntroduction"></div>
        </div>
        <div class="ProductOrdering-title">选择配置</div>
        <div style="display: flex; margin-bottom: 30px; align-items: center">
          <div style="width: 100px">套餐类型</div>
          <div>
            <a-radio-group v-model="TypePackage" @change="onChange">
              <a-radio-button
                value="a"
                v-if="service.package.length !== 0"
                style="width: 120px; text-align: center"
              >
                固定套餐
              </a-radio-button>
              <a-radio-button
                value="b"
                style="width: 120px; text-align: center"
                v-if="code !== 'liuliang' && code !== 'kongjian' && code !== 'luzhi'"
              >
               <!-- &nbsp; {{ TypePackage === 'b' && code === 'liuliang' ||  TypePackage === 'b' && code === 'kongjian' ? 'G' : TypePackage === 'b' && code === 'luzhi' ? '小时' : '' }} -->
                自定义套餐包 
              </a-radio-button>
              <!-- <a-radio-button value="c" style="width: 120px;text-align: center">
            永久购买
          </a-radio-button> -->
            </a-radio-group>
          </div>
        </div>
        <div
          style="display: flex; align-items: center; margin-bottom: 30px"
          v-if="TypePackage === 'a'"
        >
          <div style="width: 100px">套餐包内容</div>
          <div style="display: flex" class="package">
            <a-radio-group v-model="produce" @change="changProduce">
              <a-radio-button
                :value="item"
                v-for="(item, index) in service.package"
                :key="index"
                :class="{ selectPackage: produce.id == item.id }"
              >
                <span style="color: #333333"
                  >{{ item.packageNums }}{{ item.unit }}&ensp;&ensp;<span
                    class="hhh"
                  >
                    {{ item.packageUnitPrice }}元/{{ item.unit }}
                  </span>
                </span>
              </a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <div
          style="display: flex; align-items: center; margin-bottom: 30px"
          v-if="TypePackage === 'a' || TypePackage === 'b'"
        >
          <div style="width: 100px">购买数量</div>
          <div>
            <div style="display: flex; align-items: center">
              <a-button
                style="border-radius: unset"
                :disabled="TypePackage === 'a' ? number === 1 : number === 1"
                @click="minus"
                >-</a-button
              >
              <!-- <div class="inputDiv"> -->
              <a-input-number
                v-model="number"
                @change="numberChange"
                @blur="blur"
                :min="1"
              ></a-input-number>
              <!-- </div> -->
              <a-button style="border-radius: unset" @click="add">+</a-button>
            </div>
            <!-- <div v-if="TypePackage === 'b' " style="font-size: 12px;color: #bdbdbd;margin-top: 5px">
              输入所需要的短信条数，最低为1百条，{{service.service.discountPrice}}元/条
           </div> -->
          </div>
        </div>
        <div style="display: flex; margin-bottom: 30px">
          <div style="width: 100px; padding-top: 5px">有效期</div>
          <div>
            <div class="btn">
              <span v-if="TypePackage == 'a'"
                >{{ produce.periodOfValidity }}月</span
              >
              <span v- v-else-if="TypePackage == 'b'"
                >{{ service.service.periodOfValidity
                }}{{ service.service.unit }}</span
              >
            </div>
            <div style="font-size: 12px; color: #bdbdbd; margin-top: 5px">
              <span v-if="TypePackage == 'a'"
                >自购买之日起{{ produce.periodOfValidity
                }}{{
                  produce.periodOfValidityUnit
                }}内有效，过期销毁资源，不支持延期和退款</span
              >
              <span v-else
                >自购买之日起{{ service.service.periodOfValidity
                }}{{
                  service.service.unit
                }}内有效，支付成功24小时后不支持退款</span
              >
            </div>
          </div>
        </div>
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          display: 'flex',
          justifyContent: 'right',
          alignItems: 'center',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <div class="btn-left">
          <div>
            总费用<span style="font-size: 16px; color: #00c024"
              >￥
              <span style="font-size: 18px">{{ totalMoney.money }}</span></span
            >
          </div>
          <div class="yMoney">{{ totalMoney.moneyYj }}</div>
        </div>
        <a-button
          style="margin-left: 15px"
          @click="addShopBag"
          v-if="bagButton"
        >
          加入购物袋
        </a-button>
        <a-button style="margin-left: 15px" type="primary" @click="submit">
          立即下单
        </a-button>
      </div>
    </a-modal>
    <ProductinforNew
      v-if="ProductVisible"
      :visible="ProductVisible"
      :orderNumber="orderNumber"
      v-on:closeProductinfor="closeProductinfor"
    >
    </ProductinforNew>
  </div>
</template>

<script>
import {
  getPackage,
  confirmOrder,
  getPackageMoney,
  addShop,
 
} from "@/service/authentication";
import ProductinforNew from "./ProductinforNew.vue";
export default {
  name: "ProductOrdering",
  components: { ProductinforNew },
  props: {
    visible: {
      type: Boolean,
    },
    code: {
      type: String,
    },
    bagButton: {
      type: Boolean,
      default: false,
    },
    conventionCode: {
      type: String,
    },
  },
  data() {
    return {
      number: 1,
      TypePackage: "a",
      service: {},
      list: [],
      produce: {},
      ProductVisible: false,
      orderNumber: "",
      totalMoney: {},
    };
  },
  //  computed: {

  //    price() {
  //     if(this.TypePackage=='a'){
  //         return  (this.number*this.produce.totalPrice).toFixed(2) //优惠价
  //     }
  //     else{
  //         return (this.service.service.discountPrice*this.number).toFixed(2) //优惠价
  //     }
  //    },
  //    MorePrice(){
  //     if(this.TypePackage=='a'){
  //      return  (this.number*this.produce.packageNums*this.service.service.price).toFixed(2)  // 原价
  //     }
  //     else{
  //         return (this.service.service.price*this.number).toFixed(2)
  //     }
  //    }
  //  },
  created() {
    this.getPackageDetail(this.code);
  },
  methods: {
    async getPackageDetail(code) {
      const res = await getPackage(code);
      if (res.code == 0) {
        if (res.data.package.length !== 0) {
          this.service = res.data;
          this.produce = this.service.package[0]; //默认现在第一个套餐内容
          await this.Money();
        } else {
          this.service = res.data;
          this.produce = {};
          this.number = 1;
          this.TypePackage = "b";
          await this.Money();
        }
      }
    },
    // // 计算价格
    async Money() {
      let data = {
        packageId: this.produce ? this.produce.id : "",
        serviceCode: this.code,
        productNum: this.number,
      };
      const res = await getPackageMoney(data);
      if (res.code == 0) {
        this.totalMoney = res.data;
      }
    },
    handleClose() {
      let visible = false;
      this.$emit("closeProductOrdering", visible); //子组件向父组件传值（开关）
    },
    async onChange() {
      this.number = 1;
      if (this.TypePackage == "a") {
        this.produce = this.service.package[0];
      } else {
        this.produce = {};
        this.number = 1;
      }
      await this.Money();
    },
    add() {
      this.number++;
      this.Money();
    },
    minus() {
      this.number--;
      this.Money();
    },
    changProduce() {
      this.Money();
      //    console.log(this.produce);
    },
    async submit() {
      const res = await confirmOrder(
        this.code,
        this.produce ? this.produce.id : "",
        this.number
      );
      if (res.code == 0) {
        this.$message.success("下单成功！");
        this.ProductVisible = true;
        this.orderNumber = res.data.order;
      } else {
        this.$message.warn(res.message);
      }
    },
    closeProductinfor(val) {
      this.ProductVisible = val;
    },
    numberChange(e) {
      this.Money();
      // console.log(e.target.value);
    },
    blur() {
      if (!this.number) {
        this.number = 1;
        this.Money();
      }
    },
    async addShopBag() {
      const res = await addShop(
        this.code,
        this.produce ? this.produce.id : "",
        this.number,
        this.conventionCode
      );
     if(res.code==0){
         this.$message.success('加入购物袋成功！')
         this.handleClose()
         this.$parent.getList(this.conventionCode)
     }
     else{
       this.$message.warn(res.message)
     }
    },
  },
};
</script>

<style scoped lang="scss">
.ProductOrdering-title {
  height: 25px;
  line-height: 25px;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  border-left: 5px solid #1890ff;
  padding-left: 10px;
  margin-bottom: 20px;
  .ExampleEffect {
    margin-left: 10px;
    font-size: 14px;
    font-weight: 400;
  }
}
.notice {
  margin: 20px 0;
}
.PackageContent-col {
  display: flex;
  justify-content: space-around;
  border: 1px solid #d9d9d9;
  width: 150px;
  height: 35px;
  line-height: 35px;
  margin-right: 10px;
}
.PackageContent-col-hover {
  display: flex;
  justify-content: space-around;
  border: 1px solid #d9d9d9;
  width: 150px;
  height: 35px;
  line-height: 35px;
  margin-left: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
.inputDiv {
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  height: 32px;
  line-height: 32px;
  width: 50px;
  text-align: center;
}
.btn {
  width: 150px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  background-color: #0052d9;
  color: white;
}
.yMoney {
  text-decoration: line-through;
  color: #929292;
}
.btn-left {
  font-size: 12px;
  color: #333333;
  margin-right: 10px;
}
.hhh {
  color: #e2590e;
}
// .package{
//     width:150px;
//     border: 1px solid #929292;
//     // outline:none
//     margin-right: 20px;
//     // box-shadow: none !important;

// }
// .package{
// // .ant-radio-button-wrapper {
// //   margin-right: 20px;
// //   // border-radius: 100px;
// //   border-left: 1px solid #d9d9d9;
// //   &::before {
// //     display: none;// 隐藏分界线
// //   }
// // }
// .ant-radio-button-wrapper:focus-within{
//     outline: none  !important;
// }
// }
.package {
  .ant-radio-button-wrapper {
    // width:140px;
    padding: 0px 20px;
    border: 1px solid #ababab;
    margin-right: 20px;
    height: 35px;
    line-height: 35px;
    // background: #0052d9;
  }
  .ant-radio-button-wrapper:before {
    content: none;
  }
  .ant-radio-button-wrapper:focus-within {
    outline: none;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.2);
  }
}
.selectPackage {
  background: #f5f5f6;
  box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.1);

  //
  //   .ant-radio-button-wrapper{
  //     width:140px;
  //     border: 1px solid #ababab;
  //     margin-right:20px;
  //     background: #0052d9;

  // }
}
// ::v-deep .ant-input-number-input {
//   text-align: center;
//   border-radius: 0px;
// outline: none;
// border-top: 1px solid #d9d9d9;
// border-bottom: 1px solid #d9d9d9;
// height: 32px;
// line-height: 32px;
// width: 50px;
// text-align: center;
// border-left: none;
// border-right: none;
// border-radius: 0px;
// }
// .ant-input-number:focus {
//   outline: none;
//   box-shadow: none !important;
//   border-color: #d9d9d9; /* 可选：保持默认边框颜色 */
// }
::v-deep .ant-input-number-handler-wrap {
  display: none;
}

::v-deep .ant-input-number-input {
  text-align: center !important;
  border-radius: 0px;
  //  border-right: none !important;
  //  border-left: none !important;
  //  width: 40px !important;
  //  border-radius: 110px;
}
::v-deep .ant-input-number {
   border-radius: 0px;
}
</style>
